// extracted by mini-css-extract-plugin
module.exports = {"tokenLogo":"styles_tokenLogo__2bl4E","lg":"styles_lg__wVwv8","md":"styles_md__2TNN7","sm":"styles_sm__walun","xs":"styles_xs__3LIIS"};